var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-wrapper", class: _vm.classObj },
    [
      false
        ? [_vm._m(0)]
        : [
            _vm.device === "mobile" && _vm.sidebar.opened
              ? _c("div", {
                  staticClass: "drawer-bg",
                  on: { click: _vm.handleClickOutside }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("sidebar", { staticClass: "sidebar-container" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "main-container" },
              [
                _c(
                  "div",
                  { class: { "fixed-header": _vm.fixedHeader } },
                  [_c("navbar")],
                  1
                ),
                _vm._v(" "),
                _c("app-main")
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "text-align": "center" } }, [
      _c("p", [_vm._v("Under maintenance")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }